/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import {FooterCss} from './styles';


import Whatss from "@/assets/Images/whatsapp.png";
import Linkendin from "@/assets/Images/linkedin.png";
import Insta from "@/assets/Images/instagram.png";

import Zest from "@/assets/Images/LogoZest.png";
import EmpresaMulher from "@/assets/Images/empresa-de-mulheres.png";

export function Footer(){   

    return(       
      <FooterCss>
		  <div className="contactBottom">  
          <div className="container"> 
            <div className="footerBar">
              <div id="redes">
                <a
                  href="https://wa.me/5511980130098"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={Whatss}
                    className="whats"
                    alt="Whatsapp"
                    title="Fale Conosco"
                  />
                </a>

                <a
                  href="https://www.instagram.com/zest.ag/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={Insta}
                    className="insta"
                    alt="Instagram Zest 1"
                    title="Instagram Zest 1"
                  />
                </a>

                <a
                  href="https://www.linkedin.com/company/zest1"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={Linkendin}
                    className="linkedin"
                    alt="Linkedin Zest 1"
                    title="Linkedin Zest 1"
                  />
                </a>
              </div>

              <div id="logotipos">
                <img src={Zest} alt="Zest One" title="Zest 1" />
                <img src={EmpresaMulher} alt="Woman Owned" title="Woman Owned" />
              </div>
            </div>
          </div>
        </div>
      </FooterCss>       
    )
}